import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import { IoMdReturnLeft } from "react-icons/io";
import { server } from "../common";
import { AxiosError } from "axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelectAccess } from "../store/stateFunctions";

const initialValues = {
  title: "",
  descr: "",

  image: null,
};

const initialValues2 = {
  new_priority: "",
};

const swalalert = withReactContent(Swal);

const AddBlock = ({ role }) => {
  const user = useSelectAccess("Super Admin");
      const token = localStorage.getItem("superadminToken");

  const [showmodel, setShowModel] = useState(false);
  const [arrangedata, setArrangeData] = useState(null);
  const handleshowSequence = (item) => {
    setShowModel(true);
    setArrangeData(item);
  };

  const handleCloseSequence = () => setShowModel(false);

  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setIsEditMode(false);
    setSelectedData(null);
    formik.setValues(initialValues);
    setShow(true);
  };

  const handleShowEdit = (data) => {
    setSelectedData(data);
    setIsEditMode(true);
    setShow(true);
  };

  useEffect(() => {
    getData();
    // Check if in edit mode and selectedData is available
    if (isEditMode && selectedData) {
      formik.setValues({
        title: selectedData.title || "",
        descr: selectedData.description || "", // Use description from database
        image: null, // Assuming you want to keep the file input empty for security reasons
      });
    }
  }, [isEditMode, selectedData]);

  // Get
  const getData = () => {
    server
      .get("/blogs/getallblogs", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete
  const deleteBlock = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.title} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/blogs/deleteblogs/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: token,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire("Deleted!", "Block has been deleted.", "success");
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // update block - supports partial updates
  const handleUpdate = (values) => {
    const formData = new FormData();
    let hasUpdates = false;
    
    // Only append fields that have values (partial update support)
    if (values.title && values.title.trim() !== "") {
      formData.append("title", values.title);
      hasUpdates = true;
    }
    if (values.descr && values.descr.trim() !== "") {
      formData.append("description", values.descr);
      hasUpdates = true;
    }
    if (values.image) {
      formData.append("image", values.image);
      hasUpdates = true;
    }

    // Only proceed if at least one field is being updated
    if (hasUpdates) {
      server
        .put(`/blogs/updateblogs/${selectedData.id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        })
        .then(function (response) {
          formik.resetForm();
          getData();
          toast.success("Block Updated successfully");
          handleClose();
        })
        .catch(function (error) {
          if (error.response?.data?.message)
            toast.error(error.response.data.message);
          else if (error.response?.data?.error) {
            toast.error(error.response.data.error);
          } else toast.error("Failed to connect to server");
        });
    } else {
      toast.error("Please update at least one field");
    }
  };

  // Validation schema for add mode (all fields required)
  const addValidationSchema = Yup.object({
    title: Yup.string().required("Enter a Block title"),
    descr: Yup.string().required("Enter a Block description"),
    image: Yup.mixed()
      .required("Please select an image")
      .test("fileSize", "Image size must be less than 1MB", (value) =>
        value ? value.size <= 1048576 : false
      ),
  });

  // Validation schema for edit mode (all fields optional)
  const editValidationSchema = Yup.object({
    title: Yup.string(),
    descr: Yup.string(),
    image: Yup.mixed().test("fileSize", "Image size must be less than 1MB", (value) =>
      value ? value.size <= 1048576 : true
    ),
  });

const formik = useFormik({
    initialValues,
    validationSchema: isEditMode ? editValidationSchema : addValidationSchema,
    enableReinitialize: true,
    onSubmit: (values, action) => {
      if (isEditMode && selectedData) {
        // Update mode - call handleUpdate
        handleUpdate(values);
      } else {
        // Add mode
        const formData = new FormData();
        formData.append("title", values.title);
        formData.append("description", values.descr);
        formData.append("image", values.image);

        server
          .post("/blogs/addblogs", formData, {
            headers: {
              Authorization: token,
            },
          })
          .then((response) => {
            toast.success("Block Added successfully");
            action.resetForm();
            handleClose();
            getData();
          })
          .catch((error) => {
            if (error.response?.data?.error) {
              toast.error(error.response.data.error);
            } else {
              toast.error("Failed to connect to server");
            }
          });
      }
    },
  });

  //add
 const formiks = useFormik({
  initialValues: initialValues2,
  onSubmit: (values, action) => {   // ❌ onSubmit1 नव्हे → ✅ onSubmit
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("description", values.descr);
    if (values.image) {
      formData.append("image", values.image);
    }

    server
      .put(`/blogs/updateblogs/${arrangedata.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token,
        },
      })
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          toast.success("Updated successfully");
          formiks.resetForm();
          handleCloseSequence();
          getData();
        }
      })
      .catch(function (error) {
        if (error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  },
});


  // search
  const SearchData = (searchValue) => {
    server
      .get(`/block/searchblock?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/block/blockfilter?filterByDate=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user?.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <>
      {console.log(formik.values)}
      <div className="container">
        <div className="row my-3">
          {/* <div className="col-md-4">
            <input
              type="search"
              className="form-control"
              placeholder="Search "
              onChange={(e) => SearchData(e.target.value)}
            />
          </div> */}
          <div className="col-md-4"></div>
          {/* <div className="col-md-4">
            <select
              className="form-control"
              name=""
              id=""
              onChange={(e) => FilterData(e)} // Pass the event to FilterData
            >
              <option value="2days" defaultValue>
                Last 2 days
              </option>
              <option value="month" defaultValue>
                This Month
              </option>
              <option value="3months">Last 3 Months</option>
              <option value="6months">Last 6 Months</option>
            </select>
          </div> */}
        </div>
        <div className="d-flex position-relative mb-3 justify-content-center ">
          <h5 className="m-auto text-center">Add Blogs</h5>
          <Button variant="contained" color="info" onClick={handleShow}>
            Add Blogs
          </Button>

          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>
                {isEditMode ? "Edit Block Details" : "Add Block Details"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={formik.handleSubmit}>
                <div className="form-outline mb-2">
                  <TextField
                    name="title"
                    margin="dense"
                    type="text"
                    placeholder="Title"
                    variant="outlined"
                    label="Block Title"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    fullWidth
                    required={!isEditMode}
                  ></TextField>
                  {formik.errors.title ? (
                    <p className="text-danger">{formik.errors.title}</p>
                  ) : null}
                </div>

                <div className="form-outline mb-2">
                  <TextField
                    name="image"
                    margin="dense"
                    type="file"
                    variant="outlined"
                    label="Block Images"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <label htmlFor="image">Upload Image</label>
                        </InputAdornment>
                      ),
                      inputProps: {
                        accept: ".jpg, .png, .jpeg",
                        onChange: (event) => {
                          formik.setFieldValue(
                            "image",
                            event.currentTarget.files[0]
                          );
                        },
                      },
                    }}
                  />
                  {formik.errors.image ? (
                    <p className="text-danger">{formik.errors.image}</p>
                  ) : null}
                </div>
                
                <div className="form-outline mb-2">
                  <TextField
                    name="descr"
                    margin="dense"
                    type="text"
                    placeholder="Description"
                    variant="outlined"
                    label="Description"
                    value={formik.values.descr}
                    onChange={formik.handleChange}
                    fullWidth
                    required={!isEditMode}
                    multiline
                    rows={4}
                  ></TextField>
                  {formik.errors.descr ? (
                    <p className="text-danger">{formik.errors.descr}</p>
                  ) : null}
                </div>

                <div className="pt-1 mb-2 ">
                  <Button variant="contained" type="submit">
                    {isEditMode ? "Update" : "Post"}
                  </Button>
                </div>
              </form>
            </Modal.Body>
          </Modal>
        </div>
        <div className="container" style={{ overflow: "scroll" }}>
          <table className="table table-striped border">
            <thead>
              <tr>
                <th scope="col">Sr. No.</th>
                <th scope="col">Title</th>
                <th scope="col">Description</th>
                <th scope="col">Images</th>
                <th scope="col">Update</th>
                <th scope="col">Delete</th>
              
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.title}</td>
                    <td>{item.description}</td>
                    <td>
                      <a href={item.image} target="_blank">
                        <img
                          width="50"
                          height="50"
                          src={item.image}
                          // alt={item.file}
                        />
                      </a>
                    </td>

                    <td>
                      <div className="btn btn-success text-white">
                        <AiFillEdit onClick={() => handleShowEdit(item)} />
                      </div>
                    </td>
                    <td>
                      <div className="btn btn-danger text-white">
                        <AiFillDelete onClick={() => deleteBlock(item)} />
                      </div>
                    </td>
                    {/* <td>
                      <div
                        className="btn btn-info text-white text-center"
                        onClick={() => handleshowSequence(item)}
                      >
                        {item.priority}
                      </div>
                    </td> */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <Modal show={showmodel} onHide={() => setShowModel(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Change Sequence</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formiks.handleSubmit}>
            <div className="form-outline mb-2">
              <TextField
                name="new_priority"
                margin="dense"
                type="text"
                placeholder="Title"
                variant="outlined"
                label="Number"
                value={formiks.values.new_priority}
                onChange={formiks.handleChange}
                fullWidth
                required
              ></TextField>
              {formiks.errors.new_priority ? (
                <p className="text-danger">{formiks.errors.new_priority}</p>
              ) : null}
            </div>

            <div className="pt-1 mb-2 ">
              <Button variant="contained" type="submit">
                Update
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddBlock;
